var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{attrs:{"show":"","dismissible":"","variant":"primary"}},[_c('span',{staticClass:"alert-text"},[_c('strong',[_vm._v("Note:")]),_vm._v(" You are viewing this account in impersonation mode.")])])}
var staticRenderFns = []

export { render, staticRenderFns }